import Text from "../../utils/Text";
import {
    LongArrowUp, LongArrowDown, SwapText, SwapButton, SwapBody
} from "../../styles/MainOtcStyle";

const ButtonSwapComp = ({onSwapButtonClicked, activeType}) => {

    return (
        <SwapBody>
            <SwapButton active={activeType === "sell"} onClick={onSwapButtonClicked}>
                <SwapText active={activeType === "sell"}>
                    <Text tid="sell" />
                </SwapText>
                <LongArrowDown size={14} active={activeType === "sell"} />
            </SwapButton>
            <SwapButton active={activeType === "buy"} type="buy" onClick={onSwapButtonClicked}>
                <SwapText active={activeType === "buy"}>
                    <Text tid="buy" />
                </SwapText>
                <LongArrowUp size={14} active={activeType === "buy"}/>
            </SwapButton>
        </SwapBody>
    )
}

export default ButtonSwapComp;